import { sva } from "@filadd/phi-plus-styled-system/css";
export const drawerRecipe = sva({
    slots: ["topBar", "backdrop", "positioner", "content"],
    base: {
        topBar: {
            px: 4,
        },
        backdrop: {
            backdropFilter: "blur(4px)",
            background: {
                base: "black.a5",
            },
            height: "100vh",
            left: "0",
            position: "fixed",
            top: "0",
            width: "100vw",
            zIndex: "overlay",
            _open: {
                animation: "backdrop-in",
            },
            _closed: {
                animation: "backdrop-out",
            },
        },
        positioner: {
            alignItems: "center",
            display: "flex",
            height: "100dvh",
            justifyContent: "flex-start",
            position: "fixed",
            left: 0,
            top: 0,
            width: { base: "100vw", sm: "sm" },
            zIndex: "modal",
        },
        content: {
            width: "auto",
            minWidth: "auto",
            bgColor: "transparent",
            p: 0,
            _hidden: {
                display: "none",
            },
            _open: {
                animation: "drawer-in-left",
            },
            _closed: {
                animation: "drawer-out-left",
            },
        },
    },
});
//# sourceMappingURL=drawerRecipe.js.map